// components/AsthmaResultsHeader.tsx
import React, { useState, useEffect, useRef } from 'react';
import './AsthmaResultsHeader.scss';

interface AsthmaResultsHeaderProps {
  score: number;
  severity: string;
  onClick?: () => void; // Added optional prop
  round?: number | null;
}

export const AsthmaResultsHeader: React.FC<AsthmaResultsHeaderProps> = ({ score, severity, onClick, round }) => {
  const [isSticky, setIsSticky] = useState(false);
  const sentinelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsSticky(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      },
      { threshold: 0 }
    );

    if (sentinelRef.current) observer.observe(sentinelRef.current);
    return () => observer.disconnect();
  }, []);

  const getSeverityData = () => {
    switch (severity) {
      case 'קל':
        return {
          className: 'bg-green-50',
          title: 'התקף קל',
          range: `${score} נקודות (5–7)`,
        };
      case 'בינוני':
        return {
          className: 'bg-yellow-50',
          title: 'התקף בינוני',
          range: `${score} נקודות (8–11)`,
        };
      case 'קשה':
        return {
          className: 'bg-pink-50',
          title: 'התקף קשה',
          range: `${score} נקודות (12–15)`
        };
      default:
        return {
          className: 'severity-default',
          title: 'טרם נקבעה חומרה',
          range: ''
        };
    }
  };

  const style = getSeverityData();

  const getRoundLabel = () => {
    if (round === 2) return "הערכה שניה";
    if (round === 3) return "הערכה שלישית";
    return null;
  };

  const roundLabel = getRoundLabel();

  return (
    <div className="asthma-wrapper">
      <div ref={sentinelRef} style={{ height: '1px', width: '100%', background: 'transparent' }} />
      {/* Added onClick and clickable class */}
      <div
        className={`results-card ${isSticky ? 'is-sticky' : ''} ${onClick ? 'clickable-header' : ''}`}
        onClick={onClick}
      >
        {/* Hiding "Asthma Treatment" title when sticky is active is done in existing CSS or here */}
        {roundLabel && !isSticky && (
          <div className="assessment-round-label" dir="rtl">
            {roundLabel}
          </div>
        )}

        <div className="results-summary">
          <div className={`severity-indicator ${style.className}`} style={(style as any).style}>
            <div className="severity-indicator-content">
              <div className="severity-text-wrapper">
                <div className="results-title">{style.title}</div>
                <div className="results-score">{style.range}</div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};